export const INVALID_EMAIL_ERROR_MESSAGE =
  "Hmmm, that doesn't look like a valid email. Please try again.";

export const REQUIRED_EMAIL_MESSAGE = 'Required';
export const EMAIL_REGEX =
  /^[a-z0-9._%+-]*[a-z0-9_%+-]@[a-z0-9.-]+\.[a-z]{2,24}$/i;
